//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {catchError as _observableCatch, mergeMap as _observableMergeMap} from 'rxjs/operators';
import {Observable, of as _observableOf, throwError as _observableThrow} from 'rxjs';
import {Inject, Injectable, InjectionToken, Optional} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse, HttpResponseBase} from '@angular/common/http';

import dayjs from 'dayjs';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5116";
    }

    getInfo(): Observable<OfF__AnonymousType4OfStringAndString> {
        let url_ = this.baseUrl + "/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfF__AnonymousType4OfStringAndString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfF__AnonymousType4OfStringAndString>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<OfF__AnonymousType4OfStringAndString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfF__AnonymousType4OfStringAndString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStudentImage(aadhar: string | null, imageLabel: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/open-apis/student/image/{aadhar}?";
        if (aadhar === undefined || aadhar === null)
            throw new Error("The parameter 'aadhar' must be defined.");
        url_ = url_.replace("{aadhar}", encodeURIComponent("" + aadhar));
        if (imageLabel !== undefined && imageLabel !== null)
            url_ += "imageLabel=" + encodeURIComponent("" + imageLabel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetStudentImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttendanceImage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/open-apis/attendance/{id}/image";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAttendanceImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5116";
    }

    cacheInvalidate(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/admin/cache-invalidate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("head", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCacheInvalidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCacheInvalidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCacheInvalidate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCamHealthHEAD(camId: string, durationThreshold: number | null | undefined, minimal: boolean | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/admin/cam-health/{camId}?";
        if (camId === undefined || camId === null)
            throw new Error("The parameter 'camId' must be defined.");
        url_ = url_.replace("{camId}", encodeURIComponent("" + camId));
        if (durationThreshold !== undefined && durationThreshold !== null)
            url_ += "durationThreshold=" + encodeURIComponent("" + durationThreshold) + "&";
        if (minimal !== undefined && minimal !== null)
            url_ += "minimal=" + encodeURIComponent("" + minimal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("head", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCamHealthHEAD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCamHealthHEAD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCamHealthHEAD(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCamHealthGET(camId: string, durationThreshold: number | null | undefined, minimal: boolean | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/admin/cam-health/{camId}?";
        if (camId === undefined || camId === null)
            throw new Error("The parameter 'camId' must be defined.");
        url_ = url_.replace("{camId}", encodeURIComponent("" + camId));
        if (durationThreshold !== undefined && durationThreshold !== null)
            url_ += "durationThreshold=" + encodeURIComponent("" + durationThreshold) + "&";
        if (minimal !== undefined && minimal !== null)
            url_ += "minimal=" + encodeURIComponent("" + minimal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCamHealthGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCamHealthGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCamHealthGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccessResources(email: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/admin/access-resources?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessResources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessResources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAccessResources(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postStreamProxyHealth(uid: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/admin/center/stream-proxy-health/{uid}";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{uid}", encodeURIComponent("" + uid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostStreamProxyHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostStreamProxyHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPostStreamProxyHealth(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rtspServerAuth(authRequest: RtspServerAuthRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/admin/rtsp-server/auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRtspServerAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRtspServerAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRtspServerAuth(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCamreport(): Observable<CamReportItem[]> {
        let url_ = this.baseUrl + "/admin/cam-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCamreport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCamreport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CamReportItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CamReportItem[]>;
        }));
    }

    protected processGetCamreport(response: HttpResponseBase): Observable<CamReportItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CamReportItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommandCenterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5116";
    }

    getFilterProps(): Observable<FilterObjects> {
        let url_ = this.baseUrl + "/command-center/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilterProps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilterProps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilterObjects>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilterObjects>;
        }));
    }

    protected processGetFilterProps(response: HttpResponseBase): Observable<FilterObjects> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilterObjects.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCameras(camera_id: string | null | undefined, center_id: number | undefined, company_id: number | undefined, district: string | null | undefined, scheme: string | null | undefined, page: number | undefined, page_size: number | undefined): Observable<CommandCenterResponse> {
        let url_ = this.baseUrl + "/command-center/cameras?";
        if (camera_id !== undefined && camera_id !== null)
            url_ += "camera_id=" + encodeURIComponent("" + camera_id) + "&";
        if (center_id === null)
            throw new Error("The parameter 'center_id' cannot be null.");
        else if (center_id !== undefined)
            url_ += "center_id=" + encodeURIComponent("" + center_id) + "&";
        if (company_id === null)
            throw new Error("The parameter 'company_id' cannot be null.");
        else if (company_id !== undefined)
            url_ += "company_id=" + encodeURIComponent("" + company_id) + "&";
        if (district !== undefined && district !== null)
            url_ += "district=" + encodeURIComponent("" + district) + "&";
        if (scheme !== undefined && scheme !== null)
            url_ += "scheme=" + encodeURIComponent("" + scheme) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (page_size === null)
            throw new Error("The parameter 'page_size' cannot be null.");
        else if (page_size !== undefined)
            url_ += "page_size=" + encodeURIComponent("" + page_size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCameras(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCameras(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandCenterResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandCenterResponse>;
        }));
    }

    protected processGetCameras(response: HttpResponseBase): Observable<CommandCenterResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandCenterResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganisationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5116";
    }

    getUserProfile(): Observable<Auth0User> {
        let url_ = this.baseUrl + "/org/userinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Auth0User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Auth0User>;
        }));
    }

    protected processGetUserProfile(response: HttpResponseBase): Observable<Auth0User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Auth0User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllCameras(): Observable<Camera[]> {
        let url_ = this.baseUrl + "/org/all-cameras";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCameras(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCameras(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Camera[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Camera[]>;
        }));
    }

    protected processGetAllCameras(response: HttpResponseBase): Observable<Camera[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Camera.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSchemes(): Observable<Scheme[]> {
        let url_ = this.baseUrl + "/org/schemes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchemes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchemes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Scheme[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Scheme[]>;
        }));
    }

    protected processGetSchemes(response: HttpResponseBase): Observable<Scheme[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Scheme.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompanies(schemeName: string): Observable<Company[]> {
        let url_ = this.baseUrl + "/org/companies/{schemeName}";
        if (schemeName === undefined || schemeName === null)
            throw new Error("The parameter 'schemeName' must be defined.");
        url_ = url_.replace("{schemeName}", encodeURIComponent("" + schemeName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Company[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Company[]>;
        }));
    }

    protected processGetCompanies(response: HttpResponseBase): Observable<Company[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Company.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFinancialYears(): Observable<string[]> {
        let url_ = this.baseUrl + "/org/fys";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialYears(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialYears(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFinancialYears(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrainingCenters(scheme: string, companyId: number | null | undefined, fy: string | null | undefined): Observable<TrainingCenter[]> {
        let url_ = this.baseUrl + "/org/training-centers/{scheme}?";
        if (scheme === undefined || scheme === null)
            throw new Error("The parameter 'scheme' must be defined.");
        url_ = url_.replace("{scheme}", encodeURIComponent("" + scheme));
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (fy !== undefined && fy !== null)
            url_ += "fy=" + encodeURIComponent("" + fy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingCenters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCenter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCenter[]>;
        }));
    }

    protected processGetTrainingCenters(response: HttpResponseBase): Observable<TrainingCenter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingCenter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrainingCenterById(id: number): Observable<TrainingCenter> {
        let url_ = this.baseUrl + "/org/training-center/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingCenterById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingCenterById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCenter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCenter>;
        }));
    }

    protected processGetTrainingCenterById(response: HttpResponseBase): Observable<TrainingCenter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCenter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrainingCenters2(): Observable<TrainingCenter[]> {
        let url_ = this.baseUrl + "/org/training-centers-by-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingCenters2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingCenters2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCenter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCenter[]>;
        }));
    }

    protected processGetTrainingCenters2(response: HttpResponseBase): Observable<TrainingCenter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingCenter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCameras(centerId: number): Observable<Camera[]> {
        let url_ = this.baseUrl + "/org/cameras/{centerId}";
        if (centerId === undefined || centerId === null)
            throw new Error("The parameter 'centerId' must be defined.");
        url_ = url_.replace("{centerId}", encodeURIComponent("" + centerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCameras(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCameras(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Camera[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Camera[]>;
        }));
    }

    protected processGetCameras(response: HttpResponseBase): Observable<Camera[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Camera.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRecordingPaths(centerId: number, cameraId: string): Observable<string[]> {
        let url_ = this.baseUrl + "/org/camera/{centerId}/{cameraId}/recordings";
        if (centerId === undefined || centerId === null)
            throw new Error("The parameter 'centerId' must be defined.");
        url_ = url_.replace("{centerId}", encodeURIComponent("" + centerId));
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordingPaths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordingPaths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetRecordingPaths(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isSuperAdmin(): Observable<boolean> {
        let url_ = this.baseUrl + "/org/is-sa";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSuperAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSuperAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSuperAdmin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isSuperAdmin2(): Observable<boolean> {
        let url_ = this.baseUrl + "/org/is-sudo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSuperAdmin2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSuperAdmin2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSuperAdmin2(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkFeatureAccess(permission: FeaturePermissionName): Observable<boolean> {
        let url_ = this.baseUrl + "/org/feature-permission/{permission}";
        if (permission === undefined || permission === null)
            throw new Error("The parameter 'permission' must be defined.");
        url_ = url_.replace("{permission}", encodeURIComponent("" + permission));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckFeatureAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckFeatureAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckFeatureAccess(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCameraBatches(centerId: number, cameraId: string, time: dayjs.Dayjs | null | undefined): Observable<CenterBatch[]> {
        let url_ = this.baseUrl + "/org/camera/{centerId}/{cameraId}/batches?";
        if (centerId === undefined || centerId === null)
            throw new Error("The parameter 'centerId' must be defined.");
        url_ = url_.replace("{centerId}", encodeURIComponent("" + centerId));
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        if (time !== undefined && time !== null)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCameraBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCameraBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CenterBatch[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CenterBatch[]>;
        }));
    }

    protected processGetCameraBatches(response: HttpResponseBase): Observable<CenterBatch[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CenterBatch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCameraBatches2(centerId: number, time: dayjs.Dayjs | null | undefined): Observable<CenterBatch[]> {
        let url_ = this.baseUrl + "/org/camera/{centerId}/batches?";
        if (centerId === undefined || centerId === null)
            throw new Error("The parameter 'centerId' must be defined.");
        url_ = url_.replace("{centerId}", encodeURIComponent("" + centerId));
        if (time !== undefined && time !== null)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCameraBatches2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCameraBatches2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CenterBatch[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CenterBatch[]>;
        }));
    }

    protected processGetCameraBatches2(response: HttpResponseBase): Observable<CenterBatch[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CenterBatch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCamreport(): Observable<CamReportItem[]> {
        let url_ = this.baseUrl + "/org/cam-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCamreport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCamreport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CamReportItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CamReportItem[]>;
        }));
    }

    protected processGetCamreport(response: HttpResponseBase): Observable<CamReportItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CamReportItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PresenceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5116";
    }

    health(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/presence/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCenters(): Observable<DropdownItem[]> {
        let url_ = this.baseUrl + "/presence/centers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCenters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownItem[]>;
        }));
    }

    protected processGetCenters(response: HttpResponseBase): Observable<DropdownItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBatches(centerId: number | undefined): Observable<DropdownItem[]> {
        let url_ = this.baseUrl + "/presence/batches?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownItem[]>;
        }));
    }

    protected processGetBatches(response: HttpResponseBase): Observable<DropdownItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStudents(centerId: number | undefined, batchCode: string | null | undefined): Observable<Student[]> {
        let url_ = this.baseUrl + "/presence/students?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        if (batchCode !== undefined && batchCode !== null)
            url_ += "batchCode=" + encodeURIComponent("" + batchCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Student[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Student[]>;
        }));
    }

    protected processGetStudents(response: HttpResponseBase): Observable<Student[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Student.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStudent(centerId: number | undefined, batchCode: string | null | undefined, aadhar: string | null | undefined): Observable<Student[]> {
        let url_ = this.baseUrl + "/presence/student?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        if (batchCode !== undefined && batchCode !== null)
            url_ += "batchCode=" + encodeURIComponent("" + batchCode) + "&";
        if (aadhar !== undefined && aadhar !== null)
            url_ += "aadhar=" + encodeURIComponent("" + aadhar) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Student[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Student[]>;
        }));
    }

    protected processGetStudent(response: HttpResponseBase): Observable<Student[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Student.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttendanceDays(centerId: number | undefined, batchCode: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/presence/attendance-days?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        if (batchCode !== undefined && batchCode !== null)
            url_ += "batchCode=" + encodeURIComponent("" + batchCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAttendanceDays(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttendance(centerId: number | undefined, batchCode: string | null | undefined, date: string | null | undefined): Observable<LiveAttendance2[]> {
        let url_ = this.baseUrl + "/presence/attendance?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        if (batchCode !== undefined && batchCode !== null)
            url_ += "batchCode=" + encodeURIComponent("" + batchCode) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiveAttendance2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiveAttendance2[]>;
        }));
    }

    protected processGetAttendance(response: HttpResponseBase): Observable<LiveAttendance2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiveAttendance2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttendanceSummary(centerId: number | undefined, batchCode: string | null | undefined, date: string | null | undefined): Observable<LiveAttendanceDetail[]> {
        let url_ = this.baseUrl + "/presence/attendance-summary?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        if (batchCode !== undefined && batchCode !== null)
            url_ += "batchCode=" + encodeURIComponent("" + batchCode) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiveAttendanceDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiveAttendanceDetail[]>;
        }));
    }

    protected processGetAttendanceSummary(response: HttpResponseBase): Observable<LiveAttendanceDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiveAttendanceDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStudentAttendanceSummary(centerId: number | undefined, batchCode: string | null | undefined, date: string | null | undefined, aadhar: string | null | undefined): Observable<LiveAttendance2[]> {
        let url_ = this.baseUrl + "/presence/student-presence-summary?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        if (batchCode !== undefined && batchCode !== null)
            url_ += "batchCode=" + encodeURIComponent("" + batchCode) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (aadhar !== undefined && aadhar !== null)
            url_ += "aadhar=" + encodeURIComponent("" + aadhar) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentAttendanceSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentAttendanceSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiveAttendance2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiveAttendance2[]>;
        }));
    }

    protected processGetStudentAttendanceSummary(response: HttpResponseBase): Observable<LiveAttendance2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiveAttendance2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLiveAttendanceDetail(attendanceId: number | undefined): Observable<LiveAttendanceDetail[]> {
        let url_ = this.baseUrl + "/presence/attendance-details?";
        if (attendanceId === null)
            throw new Error("The parameter 'attendanceId' cannot be null.");
        else if (attendanceId !== undefined)
            url_ += "attendanceId=" + encodeURIComponent("" + attendanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiveAttendanceDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiveAttendanceDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiveAttendanceDetail[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiveAttendanceDetail[]>;
        }));
    }

    protected processGetLiveAttendanceDetail(response: HttpResponseBase): Observable<LiveAttendanceDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiveAttendanceDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerFace(centerId: number | undefined, batchId: string | null | undefined, aadhar: string | null | undefined, name: string | null | undefined, regNo: string | null | undefined, faceRecog: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/presence/register-student?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        if (aadhar !== undefined && aadhar !== null)
            url_ += "aadhar=" + encodeURIComponent("" + aadhar) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (regNo !== undefined && regNo !== null)
            url_ += "regNo=" + encodeURIComponent("" + regNo) + "&";
        if (faceRecog === null)
            throw new Error("The parameter 'faceRecog' cannot be null.");
        else if (faceRecog !== undefined)
            url_ += "faceRecog=" + encodeURIComponent("" + faceRecog) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterFace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterFace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRegisterFace(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addFaceImage(centerId: number | undefined, batchId: string | null | undefined, aadhar: string | null | undefined, imageLabel: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/presence/add-student-face-image?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        if (aadhar !== undefined && aadhar !== null)
            url_ += "aadhar=" + encodeURIComponent("" + aadhar) + "&";
        if (imageLabel !== undefined && imageLabel !== null)
            url_ += "imageLabel=" + encodeURIComponent("" + imageLabel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFaceImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFaceImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAddFaceImage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCameras(centerId: number | undefined): Observable<Camera[]> {
        let url_ = this.baseUrl + "/presence/cameras?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCameras(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCameras(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Camera[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Camera[]>;
        }));
    }

    protected processGetCameras(response: HttpResponseBase): Observable<Camera[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Camera.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    captureFrame(cameraId: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/presence/capture-frame?";
        if (cameraId !== undefined && cameraId !== null)
            url_ += "cameraId=" + encodeURIComponent("" + cameraId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaptureFrame(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaptureFrame(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCaptureFrame(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findMatch(centerId: number | undefined, batchId: string | null | undefined, mock: boolean | undefined, th: number | undefined): Observable<FaceMatchResults> {
        let url_ = this.baseUrl + "/presence/find-match?";
        if (centerId === null)
            throw new Error("The parameter 'centerId' cannot be null.");
        else if (centerId !== undefined)
            url_ += "centerId=" + encodeURIComponent("" + centerId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        if (mock === null)
            throw new Error("The parameter 'mock' cannot be null.");
        else if (mock !== undefined)
            url_ += "mock=" + encodeURIComponent("" + mock) + "&";
        if (th === null)
            throw new Error("The parameter 'th' cannot be null.");
        else if (th !== undefined)
            url_ += "th=" + encodeURIComponent("" + th) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindMatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindMatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaceMatchResults>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaceMatchResults>;
        }));
    }

    protected processFindMatch(response: HttpResponseBase): Observable<FaceMatchResults> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FaceMatchResults.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RsldcClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5116";
    }

    getSchemes(): Observable<string[]> {
        let url_ = this.baseUrl + "/rsldc/schemes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchemes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchemes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetSchemes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCompanies(scheme: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/rsldc/companies?";
        if (scheme !== undefined && scheme !== null)
            url_ += "scheme=" + encodeURIComponent("" + scheme) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCompanies(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDistricts(company: string | null | undefined, scheme: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/rsldc/districts?";
        if (company !== undefined && company !== null)
            url_ += "company=" + encodeURIComponent("" + company) + "&";
        if (scheme !== undefined && scheme !== null)
            url_ += "scheme=" + encodeURIComponent("" + scheme) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistricts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistricts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetDistricts(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBatches(scheme: string | null | undefined, company: string | null | undefined, district: string | null | undefined, date: string | null | undefined): Observable<CenterBatch2[]> {
        let url_ = this.baseUrl + "/rsldc/batches?";
        if (scheme !== undefined && scheme !== null)
            url_ += "scheme=" + encodeURIComponent("" + scheme) + "&";
        if (company !== undefined && company !== null)
            url_ += "company=" + encodeURIComponent("" + company) + "&";
        if (district !== undefined && district !== null)
            url_ += "district=" + encodeURIComponent("" + district) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CenterBatch2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CenterBatch2[]>;
        }));
    }

    protected processGetBatches(response: HttpResponseBase): Observable<CenterBatch2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CenterBatch2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBatches2(centerId: number): Observable<CenterBatch2[]> {
        let url_ = this.baseUrl + "/rsldc/batches/{centerId}";
        if (centerId === undefined || centerId === null)
            throw new Error("The parameter 'centerId' must be defined.");
        url_ = url_.replace("{centerId}", encodeURIComponent("" + centerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatches2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatches2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CenterBatch2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CenterBatch2[]>;
        }));
    }

    protected processGetBatches2(response: HttpResponseBase): Observable<CenterBatch2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CenterBatch2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StreamClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5116";
    }

    getOnlineStatus(camId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/stream/check-online/{camId}";
        if (camId === undefined || camId === null)
            throw new Error("The parameter 'camId' must be defined.");
        url_ = url_.replace("{camId}", encodeURIComponent("" + camId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetOnlineStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEzvizQuery(camId: string): Observable<DropdownItem> {
        let url_ = this.baseUrl + "/stream/ezviz-query/{camId}";
        if (camId === undefined || camId === null)
            throw new Error("The parameter 'camId' must be defined.");
        url_ = url_.replace("{camId}", encodeURIComponent("" + camId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEzvizQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEzvizQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownItem>;
        }));
    }

    protected processGetEzvizQuery(response: HttpResponseBase): Observable<DropdownItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DropdownItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;

            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkCamHealth(camId: string): Observable<CamHealthResponse> {
        let url_ = this.baseUrl + "/stream/check-cam-health/{camId}";
        if (camId === undefined || camId === null)
            throw new Error("The parameter 'camId' must be defined.");
        url_ = url_.replace("{camId}", encodeURIComponent("" + camId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCamHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCamHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CamHealthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CamHealthResponse>;
        }));
    }

    protected processCheckCamHealth(response: HttpResponseBase): Observable<CamHealthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CamHealthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    signalR(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/stream/signalr-test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignalR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignalR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSignalR(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VideoGalleryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5116";
    }

    getRecordingDays(centerId: number, cameraId: string): Observable<RecordingDay[]> {
        let url_ = this.baseUrl + "/gallery/recordings/{centerId}/{cameraId}";
        if (centerId === undefined || centerId === null)
            throw new Error("The parameter 'centerId' must be defined.");
        url_ = url_.replace("{centerId}", encodeURIComponent("" + centerId));
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordingDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordingDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordingDay[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordingDay[]>;
        }));
    }

    protected processGetRecordingDays(response: HttpResponseBase): Observable<RecordingDay[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordingDay.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRecordingsByDate(centerId: number, cameraId: string, date: string, hour: number | undefined): Observable<VideoFileSegment[]> {
        let url_ = this.baseUrl + "/gallery/recording/files/{centerId}/{cameraId}/{date}?";
        if (centerId === undefined || centerId === null)
            throw new Error("The parameter 'centerId' must be defined.");
        url_ = url_.replace("{centerId}", encodeURIComponent("" + centerId));
        if (cameraId === undefined || cameraId === null)
            throw new Error("The parameter 'cameraId' must be defined.");
        url_ = url_.replace("{cameraId}", encodeURIComponent("" + cameraId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (hour === null)
            throw new Error("The parameter 'hour' cannot be null.");
        else if (hour !== undefined)
            url_ += "hour=" + encodeURIComponent("" + hour) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordingsByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordingsByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideoFileSegment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideoFileSegment[]>;
        }));
    }

    protected processGetRecordingsByDate(response: HttpResponseBase): Observable<VideoFileSegment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VideoFileSegment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadVideo(videoLink: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/gallery/get-segment?";
        if (videoLink !== undefined && videoLink !== null)
            url_ += "videoLink=" + encodeURIComponent("" + videoLink) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadVideo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadVideo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadVideo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class OfF__AnonymousType4OfStringAndString implements IOfF__AnonymousType4OfStringAndString {
    hostname?: string | undefined;
    environment?: string | undefined;

    constructor(data?: IOfF__AnonymousType4OfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hostname = _data["hostname"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): OfF__AnonymousType4OfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new OfF__AnonymousType4OfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hostname"] = this.hostname;
        data["environment"] = this.environment;
        return data;
    }
}

export interface IOfF__AnonymousType4OfStringAndString {
    hostname?: string | undefined;
    environment?: string | undefined;
}

export class RtspServerAuthRequest implements IRtspServerAuthRequest {
    ip?: string | undefined;
    user?: string | undefined;
    password?: string | undefined;
    path?: string | undefined;
    protocol?: RtspAuthProtocol;
    id?: string | undefined;
    action?: RtspAuthAction;
    query?: string | undefined;

    constructor(data?: IRtspServerAuthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ip = _data["ip"];
            this.user = _data["user"];
            this.password = _data["password"];
            this.path = _data["path"];
            this.protocol = _data["protocol"];
            this.id = _data["id"];
            this.action = _data["action"];
            this.query = _data["query"];
        }
    }

    static fromJS(data: any): RtspServerAuthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RtspServerAuthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ip"] = this.ip;
        data["user"] = this.user;
        data["password"] = this.password;
        data["path"] = this.path;
        data["protocol"] = this.protocol;
        data["id"] = this.id;
        data["action"] = this.action;
        data["query"] = this.query;
        return data;
    }
}

export interface IRtspServerAuthRequest {
    ip?: string | undefined;
    user?: string | undefined;
    password?: string | undefined;
    path?: string | undefined;
    protocol?: RtspAuthProtocol;
    id?: string | undefined;
    action?: RtspAuthAction;
    query?: string | undefined;
}

export enum RtspAuthProtocol {
    Rtsp = 0,
    Rtmp = 1,
    Hls = 2,
    Webrtc = 3,
}

export enum RtspAuthAction {
    Read = 0,
    Publish = 1,
}

export class CamReportItem implements ICamReportItem {
    scheme?: string | undefined;
    pia?: string | undefined;
    centerName?: string | undefined;
    totalCams?: number;
    activeCams?: number;
    inactiveCams?: number;
    offtimeCams?: number;
    archivedCams?: number;
    remarks?: string | undefined;

    constructor(data?: ICamReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheme = _data["scheme"];
            this.pia = _data["pia"];
            this.centerName = _data["centerName"];
            this.totalCams = _data["totalCams"];
            this.activeCams = _data["activeCams"];
            this.inactiveCams = _data["inactiveCams"];
            this.offtimeCams = _data["offtimeCams"];
            this.archivedCams = _data["archivedCams"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): CamReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new CamReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheme"] = this.scheme;
        data["pia"] = this.pia;
        data["centerName"] = this.centerName;
        data["totalCams"] = this.totalCams;
        data["activeCams"] = this.activeCams;
        data["inactiveCams"] = this.inactiveCams;
        data["offtimeCams"] = this.offtimeCams;
        data["archivedCams"] = this.archivedCams;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ICamReportItem {
    scheme?: string | undefined;
    pia?: string | undefined;
    centerName?: string | undefined;
    totalCams?: number;
    activeCams?: number;
    inactiveCams?: number;
    offtimeCams?: number;
    archivedCams?: number;
    remarks?: string | undefined;
}

export class FilterObjects implements IFilterObjects {
    schemes?: DropdownItem[] | undefined;
    companies?: DropdownItem[] | undefined;
    fy?: DropdownItem[] | undefined;
    district?: DropdownItem[] | undefined;
    centers?: DropdownItem[] | undefined;
    cameras?: DropdownItem[] | undefined;

    constructor(data?: IFilterObjects) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["schemes"])) {
                this.schemes = [] as any;
                for (let item of _data["schemes"])
                    this.schemes!.push(DropdownItem.fromJS(item));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(DropdownItem.fromJS(item));
            }
            if (Array.isArray(_data["fy"])) {
                this.fy = [] as any;
                for (let item of _data["fy"])
                    this.fy!.push(DropdownItem.fromJS(item));
            }
            if (Array.isArray(_data["district"])) {
                this.district = [] as any;
                for (let item of _data["district"])
                    this.district!.push(DropdownItem.fromJS(item));
            }
            if (Array.isArray(_data["centers"])) {
                this.centers = [] as any;
                for (let item of _data["centers"])
                    this.centers!.push(DropdownItem.fromJS(item));
            }
            if (Array.isArray(_data["cameras"])) {
                this.cameras = [] as any;
                for (let item of _data["cameras"])
                    this.cameras!.push(DropdownItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterObjects {
        data = typeof data === 'object' ? data : {};
        let result = new FilterObjects();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.schemes)) {
            data["schemes"] = [];
            for (let item of this.schemes)
                data["schemes"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        if (Array.isArray(this.fy)) {
            data["fy"] = [];
            for (let item of this.fy)
                data["fy"].push(item.toJSON());
        }
        if (Array.isArray(this.district)) {
            data["district"] = [];
            for (let item of this.district)
                data["district"].push(item.toJSON());
        }
        if (Array.isArray(this.centers)) {
            data["centers"] = [];
            for (let item of this.centers)
                data["centers"].push(item.toJSON());
        }
        if (Array.isArray(this.cameras)) {
            data["cameras"] = [];
            for (let item of this.cameras)
                data["cameras"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterObjects {
    schemes?: DropdownItem[] | undefined;
    companies?: DropdownItem[] | undefined;
    fy?: DropdownItem[] | undefined;
    district?: DropdownItem[] | undefined;
    centers?: DropdownItem[] | undefined;
    cameras?: DropdownItem[] | undefined;
}

export class DropdownItem implements IDropdownItem {
    id?: any | undefined;
    value?: string | undefined;
    selected?: boolean;
    additionalItems?: any | undefined;

    constructor(data?: IDropdownItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.selected = _data["selected"];
            this.additionalItems = _data["additionalItems"];
        }
    }

    static fromJS(data: any): DropdownItem {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["selected"] = this.selected;
        data["additionalItems"] = this.additionalItems;
        return data;
    }
}

export interface IDropdownItem {
    id?: any | undefined;
    value?: string | undefined;
    selected?: boolean;
    additionalItems?: any | undefined;
}

export class CommandCenterResponse implements ICommandCenterResponse {
    page?: number;
    pageSize?: number;
    totalCount?: number;
    results?: Camera[] | undefined;

    constructor(data?: ICommandCenterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Camera.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommandCenterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommandCenterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommandCenterResponse {
    page?: number;
    pageSize?: number;
    totalCount?: number;
    results?: Camera[] | undefined;
}

export class Camera implements ICamera {
    id?: string | undefined;
    trainingCenterId?: number;
    trainingCenterName?: string | undefined;
    name?: string | undefined;
    location?: string | undefined;
    server?: string | undefined;
    webRtcUrl?: string | undefined;
    archived?: boolean;
    online?: boolean;
    url?: string | undefined;
    district?: string | undefined;
    companyId?: number;
    companyShortName?: string | undefined;
    scheme?: string | undefined;

    constructor(data?: ICamera) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trainingCenterId = _data["trainingCenterId"];
            this.trainingCenterName = _data["trainingCenterName"];
            this.name = _data["name"];
            this.location = _data["location"];
            this.server = _data["server"];
            this.webRtcUrl = _data["webRtcUrl"];
            this.archived = _data["archived"];
            this.online = _data["online"];
            this.url = _data["url"];
            this.district = _data["district"];
            this.companyId = _data["companyId"];
            this.companyShortName = _data["companyShortName"];
            this.scheme = _data["scheme"];
        }
    }

    static fromJS(data: any): Camera {
        data = typeof data === 'object' ? data : {};
        let result = new Camera();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trainingCenterId"] = this.trainingCenterId;
        data["trainingCenterName"] = this.trainingCenterName;
        data["name"] = this.name;
        data["location"] = this.location;
        data["server"] = this.server;
        data["webRtcUrl"] = this.webRtcUrl;
        data["archived"] = this.archived;
        data["online"] = this.online;
        data["url"] = this.url;
        data["district"] = this.district;
        data["companyId"] = this.companyId;
        data["companyShortName"] = this.companyShortName;
        data["scheme"] = this.scheme;
        return data;
    }
}

export interface ICamera {
    id?: string | undefined;
    trainingCenterId?: number;
    trainingCenterName?: string | undefined;
    name?: string | undefined;
    location?: string | undefined;
    server?: string | undefined;
    webRtcUrl?: string | undefined;
    archived?: boolean;
    online?: boolean;
    url?: string | undefined;
    district?: string | undefined;
    companyId?: number;
    companyShortName?: string | undefined;
    scheme?: string | undefined;
}

export class Auth0User implements IAuth0User {
    sub?: string | undefined;
    nickname?: string | undefined;
    name?: string | undefined;
    picture?: string | undefined;
    email?: string | undefined;
    email_verified?: boolean;
    permissions?: string[] | undefined;
    isPublic?: boolean;

    constructor(data?: IAuth0User) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sub = _data["sub"];
            this.nickname = _data["nickname"];
            this.name = _data["name"];
            this.picture = _data["picture"];
            this.email = _data["email"];
            this.email_verified = _data["email_verified"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): Auth0User {
        data = typeof data === 'object' ? data : {};
        let result = new Auth0User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sub"] = this.sub;
        data["nickname"] = this.nickname;
        data["name"] = this.name;
        data["picture"] = this.picture;
        data["email"] = this.email;
        data["email_verified"] = this.email_verified;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["isPublic"] = this.isPublic;
        return data;
    }
}

export interface IAuth0User {
    sub?: string | undefined;
    nickname?: string | undefined;
    name?: string | undefined;
    picture?: string | undefined;
    email?: string | undefined;
    email_verified?: boolean;
    permissions?: string[] | undefined;
    isPublic?: boolean;
}

export class Scheme implements IScheme {
    name?: string | undefined;
    active?: boolean;

    constructor(data?: IScheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): Scheme {
        data = typeof data === 'object' ? data : {};
        let result = new Scheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["active"] = this.active;
        return data;
    }
}

export interface IScheme {
    name?: string | undefined;
    active?: boolean;
}

export class Company implements ICompany {
    id?: number;
    name?: string | undefined;
    shortName?: string | undefined;
    active?: boolean;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["active"] = this.active;
        return data;
    }
}

export interface ICompany {
    id?: number;
    name?: string | undefined;
    shortName?: string | undefined;
    active?: boolean;
}

export class TrainingCenter implements ITrainingCenter {
    id?: number;
    centerId?: string | undefined;
    centerName?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    district?: string | undefined;
    uid?: string | undefined;
    additionalRemarks?: string | undefined;
    fy?: string | undefined;
    spocName?: string | undefined;
    active?: boolean;
    biometricEnabled?: boolean;
    companyId?: number;
    companyShortName?: string | undefined;
    scheme?: string | undefined;

    constructor(data?: ITrainingCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.centerId = _data["centerId"];
            this.centerName = _data["centerName"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.district = _data["district"];
            this.uid = _data["uid"];
            this.additionalRemarks = _data["additionalRemarks"];
            this.fy = _data["fy"];
            this.spocName = _data["spocName"];
            this.active = _data["active"];
            this.biometricEnabled = _data["biometricEnabled"];
            this.companyId = _data["companyId"];
            this.companyShortName = _data["companyShortName"];
            this.scheme = _data["scheme"];
        }
    }

    static fromJS(data: any): TrainingCenter {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["centerId"] = this.centerId;
        data["centerName"] = this.centerName;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["district"] = this.district;
        data["uid"] = this.uid;
        data["additionalRemarks"] = this.additionalRemarks;
        data["fy"] = this.fy;
        data["spocName"] = this.spocName;
        data["active"] = this.active;
        data["biometricEnabled"] = this.biometricEnabled;
        data["companyId"] = this.companyId;
        data["companyShortName"] = this.companyShortName;
        data["scheme"] = this.scheme;
        return data;
    }
}

export interface ITrainingCenter {
    id?: number;
    centerId?: string | undefined;
    centerName?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    district?: string | undefined;
    uid?: string | undefined;
    additionalRemarks?: string | undefined;
    fy?: string | undefined;
    spocName?: string | undefined;
    active?: boolean;
    biometricEnabled?: boolean;
    companyId?: number;
    companyShortName?: string | undefined;
    scheme?: string | undefined;
}

export enum FeaturePermissionName {
    Recording = 0,
    CamReportDownload = 1,
    CommandCenter = 2,
    AttendanceReports = 3,
    PTZ = 4,
}

export class CenterBatch implements ICenterBatch {
    batchCode?: string | undefined;
    trainingCenterId?: number;
    name?: string | undefined;
    cameraId?: string | undefined;
    trainer?: string | undefined;
    startDate?: dayjs.Dayjs | undefined;
    endDate?: dayjs.Dayjs | undefined;
    startTime?: dayjs.Dayjs | undefined;
    endTime?: dayjs.Dayjs | undefined;
    students?: number | undefined;
    batchStatus?: string | undefined;
    camera?: Camera2 | undefined;
    trainingCenter?: TrainingCenter2 | undefined;

    constructor(data?: ICenterBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchCode = _data["batchCode"];
            this.trainingCenterId = _data["trainingCenterId"];
            this.name = _data["name"];
            this.cameraId = _data["cameraId"];
            this.trainer = _data["trainer"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : <any>undefined;
            this.students = _data["students"];
            this.batchStatus = _data["batchStatus"];
            this.camera = _data["camera"] ? Camera2.fromJS(_data["camera"]) : <any>undefined;
            this.trainingCenter = _data["trainingCenter"] ? TrainingCenter2.fromJS(_data["trainingCenter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CenterBatch {
        data = typeof data === 'object' ? data : {};
        let result = new CenterBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchCode"] = this.batchCode;
        data["trainingCenterId"] = this.trainingCenterId;
        data["name"] = this.name;
        data["cameraId"] = this.cameraId;
        data["trainer"] = this.trainer;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["students"] = this.students;
        data["batchStatus"] = this.batchStatus;
        data["camera"] = this.camera ? this.camera.toJSON() : <any>undefined;
        data["trainingCenter"] = this.trainingCenter ? this.trainingCenter.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICenterBatch {
    batchCode?: string | undefined;
    trainingCenterId?: number;
    name?: string | undefined;
    cameraId?: string | undefined;
    trainer?: string | undefined;
    startDate?: dayjs.Dayjs | undefined;
    endDate?: dayjs.Dayjs | undefined;
    startTime?: dayjs.Dayjs | undefined;
    endTime?: dayjs.Dayjs | undefined;
    students?: number | undefined;
    batchStatus?: string | undefined;
    camera?: Camera2 | undefined;
    trainingCenter?: TrainingCenter2 | undefined;
}

export class Camera2 implements ICamera2 {
    id?: string | undefined;
    trainingCenterId?: number | undefined;
    name?: string | undefined;
    ipAddress?: string | undefined;
    location?: string | undefined;
    sn?: string | undefined;
    code?: string | undefined;
    image?: string | undefined;
    tags?: string | undefined;
    enabled?: boolean;
    mac?: string | undefined;
    rtspUrl?: string | undefined;
    holidays?: string | undefined;
    startTime?: dayjs.Dayjs | undefined;
    endTime?: dayjs.Dayjs | undefined;
    forceStart?: boolean | undefined;
    publicStream?: string | undefined;
    staticIp?: boolean | undefined;
    lanIp?: string | undefined;
    publishUrl?: string | undefined;
    ezvizCloud?: boolean | undefined;
    ezvizUrl?: string | undefined;
    lanMac?: string | undefined;
    subscriptionActive?: boolean | undefined;
    archivedCamRecordings?: ArchivedCamRecording[] | undefined;
    centerBatches?: CenterBatch[] | undefined;
    trainingCenter?: TrainingCenter2 | undefined;

    constructor(data?: ICamera2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trainingCenterId = _data["trainingCenterId"];
            this.name = _data["name"];
            this.ipAddress = _data["ipAddress"];
            this.location = _data["location"];
            this.sn = _data["sn"];
            this.code = _data["code"];
            this.image = _data["image"];
            this.tags = _data["tags"];
            this.enabled = _data["enabled"];
            this.mac = _data["mac"];
            this.rtspUrl = _data["rtspUrl"];
            this.holidays = _data["holidays"];
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : <any>undefined;
            this.forceStart = _data["forceStart"];
            this.publicStream = _data["publicStream"];
            this.staticIp = _data["staticIp"];
            this.lanIp = _data["lanIp"];
            this.publishUrl = _data["publishUrl"];
            this.ezvizCloud = _data["ezvizCloud"];
            this.ezvizUrl = _data["ezvizUrl"];
            this.lanMac = _data["lanMac"];
            this.subscriptionActive = _data["subscriptionActive"];
            if (Array.isArray(_data["archivedCamRecordings"])) {
                this.archivedCamRecordings = [] as any;
                for (let item of _data["archivedCamRecordings"])
                    this.archivedCamRecordings!.push(ArchivedCamRecording.fromJS(item));
            }
            if (Array.isArray(_data["centerBatches"])) {
                this.centerBatches = [] as any;
                for (let item of _data["centerBatches"])
                    this.centerBatches!.push(CenterBatch.fromJS(item));
            }
            this.trainingCenter = _data["trainingCenter"] ? TrainingCenter2.fromJS(_data["trainingCenter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Camera2 {
        data = typeof data === 'object' ? data : {};
        let result = new Camera2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trainingCenterId"] = this.trainingCenterId;
        data["name"] = this.name;
        data["ipAddress"] = this.ipAddress;
        data["location"] = this.location;
        data["sn"] = this.sn;
        data["code"] = this.code;
        data["image"] = this.image;
        data["tags"] = this.tags;
        data["enabled"] = this.enabled;
        data["mac"] = this.mac;
        data["rtspUrl"] = this.rtspUrl;
        data["holidays"] = this.holidays;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["forceStart"] = this.forceStart;
        data["publicStream"] = this.publicStream;
        data["staticIp"] = this.staticIp;
        data["lanIp"] = this.lanIp;
        data["publishUrl"] = this.publishUrl;
        data["ezvizCloud"] = this.ezvizCloud;
        data["ezvizUrl"] = this.ezvizUrl;
        data["lanMac"] = this.lanMac;
        data["subscriptionActive"] = this.subscriptionActive;
        if (Array.isArray(this.archivedCamRecordings)) {
            data["archivedCamRecordings"] = [];
            for (let item of this.archivedCamRecordings)
                data["archivedCamRecordings"].push(item.toJSON());
        }
        if (Array.isArray(this.centerBatches)) {
            data["centerBatches"] = [];
            for (let item of this.centerBatches)
                data["centerBatches"].push(item.toJSON());
        }
        data["trainingCenter"] = this.trainingCenter ? this.trainingCenter.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICamera2 {
    id?: string | undefined;
    trainingCenterId?: number | undefined;
    name?: string | undefined;
    ipAddress?: string | undefined;
    location?: string | undefined;
    sn?: string | undefined;
    code?: string | undefined;
    image?: string | undefined;
    tags?: string | undefined;
    enabled?: boolean;
    mac?: string | undefined;
    rtspUrl?: string | undefined;
    holidays?: string | undefined;
    startTime?: dayjs.Dayjs | undefined;
    endTime?: dayjs.Dayjs | undefined;
    forceStart?: boolean | undefined;
    publicStream?: string | undefined;
    staticIp?: boolean | undefined;
    lanIp?: string | undefined;
    publishUrl?: string | undefined;
    ezvizCloud?: boolean | undefined;
    ezvizUrl?: string | undefined;
    lanMac?: string | undefined;
    subscriptionActive?: boolean | undefined;
    archivedCamRecordings?: ArchivedCamRecording[] | undefined;
    centerBatches?: CenterBatch[] | undefined;
    trainingCenter?: TrainingCenter2 | undefined;
}

export class ArchivedCamRecording implements IArchivedCamRecording {
    centerId?: number;
    cameraId?: string | undefined;
    recFolder?: string | undefined;
    camName?: string | undefined;
    camera?: Camera2 | undefined;
    center?: TrainingCenter2 | undefined;

    constructor(data?: IArchivedCamRecording) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.centerId = _data["centerId"];
            this.cameraId = _data["cameraId"];
            this.recFolder = _data["recFolder"];
            this.camName = _data["camName"];
            this.camera = _data["camera"] ? Camera2.fromJS(_data["camera"]) : <any>undefined;
            this.center = _data["center"] ? TrainingCenter2.fromJS(_data["center"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArchivedCamRecording {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivedCamRecording();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["centerId"] = this.centerId;
        data["cameraId"] = this.cameraId;
        data["recFolder"] = this.recFolder;
        data["camName"] = this.camName;
        data["camera"] = this.camera ? this.camera.toJSON() : <any>undefined;
        data["center"] = this.center ? this.center.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArchivedCamRecording {
    centerId?: number;
    cameraId?: string | undefined;
    recFolder?: string | undefined;
    camName?: string | undefined;
    camera?: Camera2 | undefined;
    center?: TrainingCenter2 | undefined;
}

export class TrainingCenter2 implements ITrainingCenter2 {
    id?: number;
    centerId?: string | undefined;
    companyId?: number | undefined;
    centerName?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    district?: string | undefined;
    uid?: string | undefined;
    proxyLastOnline?: dayjs.Dayjs | undefined;
    slug?: string | undefined;
    streamServer?: string | undefined;
    additionalRemarks?: string | undefined;
    fy?: string | undefined;
    spocName?: string | undefined;
    active?: boolean;
    biometricEnabled?: boolean;
    archivedCamRecordings?: ArchivedCamRecording[] | undefined;
    archivedCams?: ArchivedCam[] | undefined;
    cameras?: Camera2[] | undefined;
    centerBatches?: CenterBatch[] | undefined;
    centerStudents?: CenterStudent[] | undefined;
    company?: Company2 | undefined;
    liveAttendances?: LiveAttendance[] | undefined;
    streamServerNavigation?: StreamingServer | undefined;
    trainingCenterBatches?: TrainingCenterBatch[] | undefined;

    constructor(data?: ITrainingCenter2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.centerId = _data["centerId"];
            this.companyId = _data["companyId"];
            this.centerName = _data["centerName"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.district = _data["district"];
            this.uid = _data["uid"];
            this.proxyLastOnline = _data["proxyLastOnline"] ? dayjs(_data["proxyLastOnline"].toString()) : <any>undefined;
            this.slug = _data["slug"];
            this.streamServer = _data["streamServer"];
            this.additionalRemarks = _data["additionalRemarks"];
            this.fy = _data["fy"];
            this.spocName = _data["spocName"];
            this.active = _data["active"];
            this.biometricEnabled = _data["biometricEnabled"];
            if (Array.isArray(_data["archivedCamRecordings"])) {
                this.archivedCamRecordings = [] as any;
                for (let item of _data["archivedCamRecordings"])
                    this.archivedCamRecordings!.push(ArchivedCamRecording.fromJS(item));
            }
            if (Array.isArray(_data["archivedCams"])) {
                this.archivedCams = [] as any;
                for (let item of _data["archivedCams"])
                    this.archivedCams!.push(ArchivedCam.fromJS(item));
            }
            if (Array.isArray(_data["cameras"])) {
                this.cameras = [] as any;
                for (let item of _data["cameras"])
                    this.cameras!.push(Camera2.fromJS(item));
            }
            if (Array.isArray(_data["centerBatches"])) {
                this.centerBatches = [] as any;
                for (let item of _data["centerBatches"])
                    this.centerBatches!.push(CenterBatch.fromJS(item));
            }
            if (Array.isArray(_data["centerStudents"])) {
                this.centerStudents = [] as any;
                for (let item of _data["centerStudents"])
                    this.centerStudents!.push(CenterStudent.fromJS(item));
            }
            this.company = _data["company"] ? Company2.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["liveAttendances"])) {
                this.liveAttendances = [] as any;
                for (let item of _data["liveAttendances"])
                    this.liveAttendances!.push(LiveAttendance.fromJS(item));
            }
            this.streamServerNavigation = _data["streamServerNavigation"] ? StreamingServer.fromJS(_data["streamServerNavigation"]) : <any>undefined;
            if (Array.isArray(_data["trainingCenterBatches"])) {
                this.trainingCenterBatches = [] as any;
                for (let item of _data["trainingCenterBatches"])
                    this.trainingCenterBatches!.push(TrainingCenterBatch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainingCenter2 {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCenter2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["centerId"] = this.centerId;
        data["companyId"] = this.companyId;
        data["centerName"] = this.centerName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["district"] = this.district;
        data["uid"] = this.uid;
        data["proxyLastOnline"] = this.proxyLastOnline ? this.proxyLastOnline.toISOString() : <any>undefined;
        data["slug"] = this.slug;
        data["streamServer"] = this.streamServer;
        data["additionalRemarks"] = this.additionalRemarks;
        data["fy"] = this.fy;
        data["spocName"] = this.spocName;
        data["active"] = this.active;
        data["biometricEnabled"] = this.biometricEnabled;
        if (Array.isArray(this.archivedCamRecordings)) {
            data["archivedCamRecordings"] = [];
            for (let item of this.archivedCamRecordings)
                data["archivedCamRecordings"].push(item.toJSON());
        }
        if (Array.isArray(this.archivedCams)) {
            data["archivedCams"] = [];
            for (let item of this.archivedCams)
                data["archivedCams"].push(item.toJSON());
        }
        if (Array.isArray(this.cameras)) {
            data["cameras"] = [];
            for (let item of this.cameras)
                data["cameras"].push(item.toJSON());
        }
        if (Array.isArray(this.centerBatches)) {
            data["centerBatches"] = [];
            for (let item of this.centerBatches)
                data["centerBatches"].push(item.toJSON());
        }
        if (Array.isArray(this.centerStudents)) {
            data["centerStudents"] = [];
            for (let item of this.centerStudents)
                data["centerStudents"].push(item.toJSON());
        }
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.liveAttendances)) {
            data["liveAttendances"] = [];
            for (let item of this.liveAttendances)
                data["liveAttendances"].push(item.toJSON());
        }
        data["streamServerNavigation"] = this.streamServerNavigation ? this.streamServerNavigation.toJSON() : <any>undefined;
        if (Array.isArray(this.trainingCenterBatches)) {
            data["trainingCenterBatches"] = [];
            for (let item of this.trainingCenterBatches)
                data["trainingCenterBatches"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrainingCenter2 {
    id?: number;
    centerId?: string | undefined;
    companyId?: number | undefined;
    centerName?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    district?: string | undefined;
    uid?: string | undefined;
    proxyLastOnline?: dayjs.Dayjs | undefined;
    slug?: string | undefined;
    streamServer?: string | undefined;
    additionalRemarks?: string | undefined;
    fy?: string | undefined;
    spocName?: string | undefined;
    active?: boolean;
    biometricEnabled?: boolean;
    archivedCamRecordings?: ArchivedCamRecording[] | undefined;
    archivedCams?: ArchivedCam[] | undefined;
    cameras?: Camera2[] | undefined;
    centerBatches?: CenterBatch[] | undefined;
    centerStudents?: CenterStudent[] | undefined;
    company?: Company2 | undefined;
    liveAttendances?: LiveAttendance[] | undefined;
    streamServerNavigation?: StreamingServer | undefined;
    trainingCenterBatches?: TrainingCenterBatch[] | undefined;
}

export class ArchivedCam implements IArchivedCam {
    cameraId?: string | undefined;
    trainingCenterId?: number;
    camName?: string | undefined;
    trainingCenter?: TrainingCenter2 | undefined;

    constructor(data?: IArchivedCam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cameraId = _data["cameraId"];
            this.trainingCenterId = _data["trainingCenterId"];
            this.camName = _data["camName"];
            this.trainingCenter = _data["trainingCenter"] ? TrainingCenter2.fromJS(_data["trainingCenter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArchivedCam {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivedCam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cameraId"] = this.cameraId;
        data["trainingCenterId"] = this.trainingCenterId;
        data["camName"] = this.camName;
        data["trainingCenter"] = this.trainingCenter ? this.trainingCenter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArchivedCam {
    cameraId?: string | undefined;
    trainingCenterId?: number;
    camName?: string | undefined;
    trainingCenter?: TrainingCenter2 | undefined;
}

export class CenterStudent implements ICenterStudent {
    aadhar?: string | undefined;
    name?: string | undefined;
    trainingCenterId?: number;
    batchCode?: string | undefined;
    regNo?: string | undefined;
    awsFaceId?: string | undefined;
    awsImageId?: string | undefined;
    faceRecogNeeded?: boolean;
    lockEdits?: boolean;
    centerStudentsImages?: CenterStudentsImage[] | undefined;
    liveAttendanceReports?: LiveAttendanceReport[] | undefined;
    trainingCenter?: TrainingCenter2 | undefined;

    constructor(data?: ICenterStudent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aadhar = _data["aadhar"];
            this.name = _data["name"];
            this.trainingCenterId = _data["trainingCenterId"];
            this.batchCode = _data["batchCode"];
            this.regNo = _data["regNo"];
            this.awsFaceId = _data["awsFaceId"];
            this.awsImageId = _data["awsImageId"];
            this.faceRecogNeeded = _data["faceRecogNeeded"];
            this.lockEdits = _data["lockEdits"];
            if (Array.isArray(_data["centerStudentsImages"])) {
                this.centerStudentsImages = [] as any;
                for (let item of _data["centerStudentsImages"])
                    this.centerStudentsImages!.push(CenterStudentsImage.fromJS(item));
            }
            if (Array.isArray(_data["liveAttendanceReports"])) {
                this.liveAttendanceReports = [] as any;
                for (let item of _data["liveAttendanceReports"])
                    this.liveAttendanceReports!.push(LiveAttendanceReport.fromJS(item));
            }
            this.trainingCenter = _data["trainingCenter"] ? TrainingCenter2.fromJS(_data["trainingCenter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CenterStudent {
        data = typeof data === 'object' ? data : {};
        let result = new CenterStudent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aadhar"] = this.aadhar;
        data["name"] = this.name;
        data["trainingCenterId"] = this.trainingCenterId;
        data["batchCode"] = this.batchCode;
        data["regNo"] = this.regNo;
        data["awsFaceId"] = this.awsFaceId;
        data["awsImageId"] = this.awsImageId;
        data["faceRecogNeeded"] = this.faceRecogNeeded;
        data["lockEdits"] = this.lockEdits;
        if (Array.isArray(this.centerStudentsImages)) {
            data["centerStudentsImages"] = [];
            for (let item of this.centerStudentsImages)
                data["centerStudentsImages"].push(item.toJSON());
        }
        if (Array.isArray(this.liveAttendanceReports)) {
            data["liveAttendanceReports"] = [];
            for (let item of this.liveAttendanceReports)
                data["liveAttendanceReports"].push(item.toJSON());
        }
        data["trainingCenter"] = this.trainingCenter ? this.trainingCenter.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICenterStudent {
    aadhar?: string | undefined;
    name?: string | undefined;
    trainingCenterId?: number;
    batchCode?: string | undefined;
    regNo?: string | undefined;
    awsFaceId?: string | undefined;
    awsImageId?: string | undefined;
    faceRecogNeeded?: boolean;
    lockEdits?: boolean;
    centerStudentsImages?: CenterStudentsImage[] | undefined;
    liveAttendanceReports?: LiveAttendanceReport[] | undefined;
    trainingCenter?: TrainingCenter2 | undefined;
}

export class CenterStudentsImage implements ICenterStudentsImage {
    aadhar?: string | undefined;
    type?: string | undefined;
    imageBase64?: string | undefined;
    approved?: boolean;
    uploadedAt?: dayjs.Dayjs | undefined;
    aadharNavigation?: CenterStudent | undefined;

    constructor(data?: ICenterStudentsImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aadhar = _data["aadhar"];
            this.type = _data["type"];
            this.imageBase64 = _data["imageBase64"];
            this.approved = _data["approved"];
            this.uploadedAt = _data["uploadedAt"] ? dayjs(_data["uploadedAt"].toString()) : <any>undefined;
            this.aadharNavigation = _data["aadharNavigation"] ? CenterStudent.fromJS(_data["aadharNavigation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CenterStudentsImage {
        data = typeof data === 'object' ? data : {};
        let result = new CenterStudentsImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aadhar"] = this.aadhar;
        data["type"] = this.type;
        data["imageBase64"] = this.imageBase64;
        data["approved"] = this.approved;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : <any>undefined;
        data["aadharNavigation"] = this.aadharNavigation ? this.aadharNavigation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICenterStudentsImage {
    aadhar?: string | undefined;
    type?: string | undefined;
    imageBase64?: string | undefined;
    approved?: boolean;
    uploadedAt?: dayjs.Dayjs | undefined;
    aadharNavigation?: CenterStudent | undefined;
}

export class LiveAttendanceReport implements ILiveAttendanceReport {
    id?: number;
    attendanceId?: number;
    studentAadhar?: string | undefined;
    present?: boolean;
    score?: number | undefined;
    boundingBox?: string | undefined;
    attendance?: LiveAttendance | undefined;
    studentAadharNavigation?: CenterStudent | undefined;

    constructor(data?: ILiveAttendanceReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attendanceId = _data["attendanceId"];
            this.studentAadhar = _data["studentAadhar"];
            this.present = _data["present"];
            this.score = _data["score"];
            this.boundingBox = _data["boundingBox"];
            this.attendance = _data["attendance"] ? LiveAttendance.fromJS(_data["attendance"]) : <any>undefined;
            this.studentAadharNavigation = _data["studentAadharNavigation"] ? CenterStudent.fromJS(_data["studentAadharNavigation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LiveAttendanceReport {
        data = typeof data === 'object' ? data : {};
        let result = new LiveAttendanceReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attendanceId"] = this.attendanceId;
        data["studentAadhar"] = this.studentAadhar;
        data["present"] = this.present;
        data["score"] = this.score;
        data["boundingBox"] = this.boundingBox;
        data["attendance"] = this.attendance ? this.attendance.toJSON() : <any>undefined;
        data["studentAadharNavigation"] = this.studentAadharNavigation ? this.studentAadharNavigation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILiveAttendanceReport {
    id?: number;
    attendanceId?: number;
    studentAadhar?: string | undefined;
    present?: boolean;
    score?: number | undefined;
    boundingBox?: string | undefined;
    attendance?: LiveAttendance | undefined;
    studentAadharNavigation?: CenterStudent | undefined;
}

export class LiveAttendance implements ILiveAttendance {
    id?: number;
    timestamp?: dayjs.Dayjs;
    trainingCenterId?: number;
    batchCode?: string | undefined;
    totalPresence?: number;
    currentPresence?: number;
    imageUsed?: string | undefined;
    liveAttendanceReports?: LiveAttendanceReport[] | undefined;
    trainingCenter?: TrainingCenter2 | undefined;

    constructor(data?: ILiveAttendance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timestamp = _data["timestamp"] ? dayjs(_data["timestamp"].toString()) : <any>undefined;
            this.trainingCenterId = _data["trainingCenterId"];
            this.batchCode = _data["batchCode"];
            this.totalPresence = _data["totalPresence"];
            this.currentPresence = _data["currentPresence"];
            this.imageUsed = _data["imageUsed"];
            if (Array.isArray(_data["liveAttendanceReports"])) {
                this.liveAttendanceReports = [] as any;
                for (let item of _data["liveAttendanceReports"])
                    this.liveAttendanceReports!.push(LiveAttendanceReport.fromJS(item));
            }
            this.trainingCenter = _data["trainingCenter"] ? TrainingCenter2.fromJS(_data["trainingCenter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LiveAttendance {
        data = typeof data === 'object' ? data : {};
        let result = new LiveAttendance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["trainingCenterId"] = this.trainingCenterId;
        data["batchCode"] = this.batchCode;
        data["totalPresence"] = this.totalPresence;
        data["currentPresence"] = this.currentPresence;
        data["imageUsed"] = this.imageUsed;
        if (Array.isArray(this.liveAttendanceReports)) {
            data["liveAttendanceReports"] = [];
            for (let item of this.liveAttendanceReports)
                data["liveAttendanceReports"].push(item.toJSON());
        }
        data["trainingCenter"] = this.trainingCenter ? this.trainingCenter.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILiveAttendance {
    id?: number;
    timestamp?: dayjs.Dayjs;
    trainingCenterId?: number;
    batchCode?: string | undefined;
    totalPresence?: number;
    currentPresence?: number;
    imageUsed?: string | undefined;
    liveAttendanceReports?: LiveAttendanceReport[] | undefined;
    trainingCenter?: TrainingCenter2 | undefined;
}

export class Company2 implements ICompany2 {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    shortName?: string | undefined;
    scheme?: string | undefined;
    schemeNavigation?: Scheme2 | undefined;
    trainingCenters?: TrainingCenter2[] | undefined;

    constructor(data?: ICompany2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.shortName = _data["shortName"];
            this.scheme = _data["scheme"];
            this.schemeNavigation = _data["schemeNavigation"] ? Scheme2.fromJS(_data["schemeNavigation"]) : <any>undefined;
            if (Array.isArray(_data["trainingCenters"])) {
                this.trainingCenters = [] as any;
                for (let item of _data["trainingCenters"])
                    this.trainingCenters!.push(TrainingCenter2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Company2 {
        data = typeof data === 'object' ? data : {};
        let result = new Company2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["shortName"] = this.shortName;
        data["scheme"] = this.scheme;
        data["schemeNavigation"] = this.schemeNavigation ? this.schemeNavigation.toJSON() : <any>undefined;
        if (Array.isArray(this.trainingCenters)) {
            data["trainingCenters"] = [];
            for (let item of this.trainingCenters)
                data["trainingCenters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompany2 {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    shortName?: string | undefined;
    scheme?: string | undefined;
    schemeNavigation?: Scheme2 | undefined;
    trainingCenters?: TrainingCenter2[] | undefined;
}

export class Scheme2 implements IScheme2 {
    name?: string | undefined;
    sort?: number | undefined;
    companies?: Company2[] | undefined;

    constructor(data?: IScheme2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sort = _data["sort"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(Company2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Scheme2 {
        data = typeof data === 'object' ? data : {};
        let result = new Scheme2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sort"] = this.sort;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScheme2 {
    name?: string | undefined;
    sort?: number | undefined;
    companies?: Company2[] | undefined;
}

export class StreamingServer implements IStreamingServer {
    serverName?: string | undefined;
    domain?: string | undefined;
    credsRead?: string | undefined;
    credsWrite?: string | undefined;
    active?: boolean;
    apiUrl?: string | undefined;
    apiUrlLan?: string | undefined;
    streamEndpoint?: string | undefined;
    streamDc?: string | undefined;
    monitoringTool?: string | undefined;
    sysHostname?: string | undefined;
    trainingCenters?: TrainingCenter2[] | undefined;

    constructor(data?: IStreamingServer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverName = _data["serverName"];
            this.domain = _data["domain"];
            this.credsRead = _data["credsRead"];
            this.credsWrite = _data["credsWrite"];
            this.active = _data["active"];
            this.apiUrl = _data["apiUrl"];
            this.apiUrlLan = _data["apiUrlLan"];
            this.streamEndpoint = _data["streamEndpoint"];
            this.streamDc = _data["streamDc"];
            this.monitoringTool = _data["monitoringTool"];
            this.sysHostname = _data["sysHostname"];
            if (Array.isArray(_data["trainingCenters"])) {
                this.trainingCenters = [] as any;
                for (let item of _data["trainingCenters"])
                    this.trainingCenters!.push(TrainingCenter2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StreamingServer {
        data = typeof data === 'object' ? data : {};
        let result = new StreamingServer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverName"] = this.serverName;
        data["domain"] = this.domain;
        data["credsRead"] = this.credsRead;
        data["credsWrite"] = this.credsWrite;
        data["active"] = this.active;
        data["apiUrl"] = this.apiUrl;
        data["apiUrlLan"] = this.apiUrlLan;
        data["streamEndpoint"] = this.streamEndpoint;
        data["streamDc"] = this.streamDc;
        data["monitoringTool"] = this.monitoringTool;
        data["sysHostname"] = this.sysHostname;
        if (Array.isArray(this.trainingCenters)) {
            data["trainingCenters"] = [];
            for (let item of this.trainingCenters)
                data["trainingCenters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStreamingServer {
    serverName?: string | undefined;
    domain?: string | undefined;
    credsRead?: string | undefined;
    credsWrite?: string | undefined;
    active?: boolean;
    apiUrl?: string | undefined;
    apiUrlLan?: string | undefined;
    streamEndpoint?: string | undefined;
    streamDc?: string | undefined;
    monitoringTool?: string | undefined;
    sysHostname?: string | undefined;
    trainingCenters?: TrainingCenter2[] | undefined;
}

export class TrainingCenterBatch implements ITrainingCenterBatch {
    batchCode?: string | undefined;
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs | undefined;
    name?: string | undefined;
    startTime?: dayjs.Dayjs | undefined;
    endTime?: dayjs.Dayjs | undefined;
    students?: number | undefined;
    trainingCenter?: number | undefined;
    trainingCenterNavigation?: TrainingCenter2 | undefined;

    constructor(data?: ITrainingCenterBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchCode = _data["batchCode"];
            this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : <any>undefined;
            this.students = _data["students"];
            this.trainingCenter = _data["trainingCenter"];
            this.trainingCenterNavigation = _data["trainingCenterNavigation"] ? TrainingCenter2.fromJS(_data["trainingCenterNavigation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrainingCenterBatch {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCenterBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchCode"] = this.batchCode;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : <any>undefined;
        data["name"] = this.name;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["students"] = this.students;
        data["trainingCenter"] = this.trainingCenter;
        data["trainingCenterNavigation"] = this.trainingCenterNavigation ? this.trainingCenterNavigation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrainingCenterBatch {
    batchCode?: string | undefined;
    startDate?: dayjs.Dayjs;
    endDate?: dayjs.Dayjs | undefined;
    name?: string | undefined;
    startTime?: dayjs.Dayjs | undefined;
    endTime?: dayjs.Dayjs | undefined;
    students?: number | undefined;
    trainingCenter?: number | undefined;
    trainingCenterNavigation?: TrainingCenter2 | undefined;
}

export class Student implements IStudent {
    aadhar?: string | undefined;
    name?: string | undefined;
    regNo?: string | undefined;
    imageUrl?: string | undefined;
    faceRecog?: boolean;
    imageLabels?: string[] | undefined;

    constructor(data?: IStudent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aadhar = _data["aadhar"];
            this.name = _data["name"];
            this.regNo = _data["regNo"];
            this.imageUrl = _data["imageUrl"];
            this.faceRecog = _data["faceRecog"];
            if (Array.isArray(_data["imageLabels"])) {
                this.imageLabels = [] as any;
                for (let item of _data["imageLabels"])
                    this.imageLabels!.push(item);
            }
        }
    }

    static fromJS(data: any): Student {
        data = typeof data === 'object' ? data : {};
        let result = new Student();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aadhar"] = this.aadhar;
        data["name"] = this.name;
        data["regNo"] = this.regNo;
        data["imageUrl"] = this.imageUrl;
        data["faceRecog"] = this.faceRecog;
        if (Array.isArray(this.imageLabels)) {
            data["imageLabels"] = [];
            for (let item of this.imageLabels)
                data["imageLabels"].push(item);
        }
        return data;
    }
}

export interface IStudent {
    aadhar?: string | undefined;
    name?: string | undefined;
    regNo?: string | undefined;
    imageUrl?: string | undefined;
    faceRecog?: boolean;
    imageLabels?: string[] | undefined;
}

export class LiveAttendance2 implements ILiveAttendance2 {
    id?: number;
    total?: number;
    present?: number;
    day?: dayjs.Dayjs;

    constructor(data?: ILiveAttendance2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.total = _data["total"];
            this.present = _data["present"];
            this.day = _data["day"] ? dayjs(_data["day"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LiveAttendance2 {
        data = typeof data === 'object' ? data : {};
        let result = new LiveAttendance2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["total"] = this.total;
        data["present"] = this.present;
        data["day"] = this.day ? this.day.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILiveAttendance2 {
    id?: number;
    total?: number;
    present?: number;
    day?: dayjs.Dayjs;
}

export class LiveAttendanceDetail implements ILiveAttendanceDetail {
    id?: number;
    livePresenceId?: number;
    studentAadhar?: string | undefined;
    studentName?: string | undefined;
    present?: boolean;
    boundingBox?: string | undefined;

    constructor(data?: ILiveAttendanceDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.livePresenceId = _data["livePresenceId"];
            this.studentAadhar = _data["studentAadhar"];
            this.studentName = _data["studentName"];
            this.present = _data["present"];
            this.boundingBox = _data["boundingBox"];
        }
    }

    static fromJS(data: any): LiveAttendanceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new LiveAttendanceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["livePresenceId"] = this.livePresenceId;
        data["studentAadhar"] = this.studentAadhar;
        data["studentName"] = this.studentName;
        data["present"] = this.present;
        data["boundingBox"] = this.boundingBox;
        return data;
    }
}

export interface ILiveAttendanceDetail {
    id?: number;
    livePresenceId?: number;
    studentAadhar?: string | undefined;
    studentName?: string | undefined;
    present?: boolean;
    boundingBox?: string | undefined;
}

export class FaceMatchResults implements IFaceMatchResults {
    matches?: Match[] | undefined;
    noMatches?: string[] | undefined;

    constructor(data?: IFaceMatchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(Match.fromJS(item));
            }
            if (Array.isArray(_data["noMatches"])) {
                this.noMatches = [] as any;
                for (let item of _data["noMatches"])
                    this.noMatches!.push(item);
            }
        }
    }

    static fromJS(data: any): FaceMatchResults {
        data = typeof data === 'object' ? data : {};
        let result = new FaceMatchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        if (Array.isArray(this.noMatches)) {
            data["noMatches"] = [];
            for (let item of this.noMatches)
                data["noMatches"].push(item);
        }
        return data;
    }
}

export interface IFaceMatchResults {
    matches?: Match[] | undefined;
    noMatches?: string[] | undefined;
}

export class Match implements IMatch {
    id?: string | undefined;
    name?: string | undefined;
    score?: number;
    boundingBox?: BoundingBox | undefined;
    imageUrl?: string | undefined;

    constructor(data?: IMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.score = _data["score"];
            this.boundingBox = _data["boundingBox"] ? BoundingBox.fromJS(_data["boundingBox"]) : <any>undefined;
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): Match {
        data = typeof data === 'object' ? data : {};
        let result = new Match();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["score"] = this.score;
        data["boundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : <any>undefined;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IMatch {
    id?: string | undefined;
    name?: string | undefined;
    score?: number;
    boundingBox?: BoundingBox | undefined;
    imageUrl?: string | undefined;
}

export class BoundingBox implements IBoundingBox {
    height?: number;
    left?: number;
    top?: number;
    width?: number;

    constructor(data?: IBoundingBox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.height = _data["height"];
            this.left = _data["left"];
            this.top = _data["top"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any): BoundingBox {
        data = typeof data === 'object' ? data : {};
        let result = new BoundingBox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["height"] = this.height;
        data["left"] = this.left;
        data["top"] = this.top;
        data["width"] = this.width;
        return data;
    }
}

export interface IBoundingBox {
    height?: number;
    left?: number;
    top?: number;
    width?: number;
}

export class CenterBatch2 implements ICenterBatch2 {
    district?: string | undefined;
    schemeName?: string | undefined;
    tppiaName?: string | undefined;
    sdcCode?: string | undefined;
    sdcAddress?: string | undefined;
    centerHeadName?: string | undefined;
    centerHeadContactNo?: string | undefined;
    sector?: string | undefined;
    batchCourse?: string | undefined;
    batchCode?: string | undefined;
    batchStartDate?: string | undefined;
    batchEndDate?: string | undefined;
    batchStartTime?: string | undefined;
    batchEndTime?: string | undefined;
    batchType?: string | undefined;
    underTrainingAspirants?: string | undefined;
    presentAspirants?: string | undefined;
    batchStatus?: string | undefined;

    constructor(data?: ICenterBatch2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.district = _data["district"];
            this.schemeName = _data["schemeName"];
            this.tppiaName = _data["tppiaName"];
            this.sdcCode = _data["sdcCode"];
            this.sdcAddress = _data["sdcAddress"];
            this.centerHeadName = _data["centerHeadName"];
            this.centerHeadContactNo = _data["centerHeadContactNo"];
            this.sector = _data["sector"];
            this.batchCourse = _data["batchCourse"];
            this.batchCode = _data["batchCode"];
            this.batchStartDate = _data["batchStartDate"];
            this.batchEndDate = _data["batchEndDate"];
            this.batchStartTime = _data["batchStartTime"];
            this.batchEndTime = _data["batchEndTime"];
            this.batchType = _data["batchType"];
            this.underTrainingAspirants = _data["underTrainingAspirants"];
            this.presentAspirants = _data["presentAspirants"];
            this.batchStatus = _data["batchStatus"];
        }
    }

    static fromJS(data: any): CenterBatch2 {
        data = typeof data === 'object' ? data : {};
        let result = new CenterBatch2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["district"] = this.district;
        data["schemeName"] = this.schemeName;
        data["tppiaName"] = this.tppiaName;
        data["sdcCode"] = this.sdcCode;
        data["sdcAddress"] = this.sdcAddress;
        data["centerHeadName"] = this.centerHeadName;
        data["centerHeadContactNo"] = this.centerHeadContactNo;
        data["sector"] = this.sector;
        data["batchCourse"] = this.batchCourse;
        data["batchCode"] = this.batchCode;
        data["batchStartDate"] = this.batchStartDate;
        data["batchEndDate"] = this.batchEndDate;
        data["batchStartTime"] = this.batchStartTime;
        data["batchEndTime"] = this.batchEndTime;
        data["batchType"] = this.batchType;
        data["underTrainingAspirants"] = this.underTrainingAspirants;
        data["presentAspirants"] = this.presentAspirants;
        data["batchStatus"] = this.batchStatus;
        return data;
    }
}

export interface ICenterBatch2 {
    district?: string | undefined;
    schemeName?: string | undefined;
    tppiaName?: string | undefined;
    sdcCode?: string | undefined;
    sdcAddress?: string | undefined;
    centerHeadName?: string | undefined;
    centerHeadContactNo?: string | undefined;
    sector?: string | undefined;
    batchCourse?: string | undefined;
    batchCode?: string | undefined;
    batchStartDate?: string | undefined;
    batchEndDate?: string | undefined;
    batchStartTime?: string | undefined;
    batchEndTime?: string | undefined;
    batchType?: string | undefined;
    underTrainingAspirants?: string | undefined;
    presentAspirants?: string | undefined;
    batchStatus?: string | undefined;
}

export class CamHealthResponse implements ICamHealthResponse {
    seconds_threshold?: number | undefined;
    tcpOnline?: boolean;
    timeBoundary?: boolean;
    lastSegmentTime?: dayjs.Dayjs;
    lastSegmentTrue?: boolean;
    status?: CamHealthResultType;
    statusText?: string | undefined;

    constructor(data?: ICamHealthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seconds_threshold = _data["seconds_threshold"];
            this.tcpOnline = _data["tcpOnline"];
            this.timeBoundary = _data["timeBoundary"];
            this.lastSegmentTime = _data["lastSegmentTime"] ? dayjs(_data["lastSegmentTime"].toString()) : <any>undefined;
            this.lastSegmentTrue = _data["lastSegmentTrue"];
            this.status = _data["status"];
            this.statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): CamHealthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CamHealthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seconds_threshold"] = this.seconds_threshold;
        data["tcpOnline"] = this.tcpOnline;
        data["timeBoundary"] = this.timeBoundary;
        data["lastSegmentTime"] = this.lastSegmentTime ? this.lastSegmentTime.toISOString() : <any>undefined;
        data["lastSegmentTrue"] = this.lastSegmentTrue;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface ICamHealthResponse {
    seconds_threshold?: number | undefined;
    tcpOnline?: boolean;
    timeBoundary?: boolean;
    lastSegmentTime?: dayjs.Dayjs;
    lastSegmentTrue?: boolean;
    status?: CamHealthResultType;
    statusText?: string | undefined;
}

export enum CamHealthResultType {
    Online = 0,
    Offline = 1,
    TimeOff = 2,
    PoorConnectivity = 3,
}

export class RecordingDay implements IRecordingDay {
    name?: string | undefined;
    date?: dayjs.Dayjs;
    month?: number;
    day?: number;
    year?: number;
    monthStr?: string | undefined;

    constructor(data?: IRecordingDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.date = _data["date"] ? dayjs(_data["date"].toString()) : <any>undefined;
            this.month = _data["month"];
            this.day = _data["day"];
            this.year = _data["year"];
            this.monthStr = _data["monthStr"];
        }
    }

    static fromJS(data: any): RecordingDay {
        data = typeof data === 'object' ? data : {};
        let result = new RecordingDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["month"] = this.month;
        data["day"] = this.day;
        data["year"] = this.year;
        data["monthStr"] = this.monthStr;
        return data;
    }
}

export interface IRecordingDay {
    name?: string | undefined;
    date?: dayjs.Dayjs;
    month?: number;
    day?: number;
    year?: number;
    monthStr?: string | undefined;
}

export class VideoFileSegment implements IVideoFileSegment {
    name?: string | undefined;
    creationTime?: string | undefined;
    fullPath?: string | undefined;
    videoDuration?: number;
    timeStamp?: dayjs.Dayjs;
    time?: string | undefined;
    timeRange?: ValueTupleOfStringAndString;
    hour?: number;
    minute?: number;
    hourStr?: string | undefined;

    constructor(data?: IVideoFileSegment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.creationTime = _data["creationTime"];
            this.fullPath = _data["fullPath"];
            this.videoDuration = _data["videoDuration"];
            this.timeStamp = _data["timeStamp"] ? dayjs(_data["timeStamp"].toString()) : <any>undefined;
            this.time = _data["time"];
            this.timeRange = _data["timeRange"] ? ValueTupleOfStringAndString.fromJS(_data["timeRange"]) : <any>undefined;
            this.hour = _data["hour"];
            this.minute = _data["minute"];
            this.hourStr = _data["hourStr"];
        }
    }

    static fromJS(data: any): VideoFileSegment {
        data = typeof data === 'object' ? data : {};
        let result = new VideoFileSegment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["creationTime"] = this.creationTime;
        data["fullPath"] = this.fullPath;
        data["videoDuration"] = this.videoDuration;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["time"] = this.time;
        data["timeRange"] = this.timeRange ? this.timeRange.toJSON() : <any>undefined;
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        data["hourStr"] = this.hourStr;
        return data;
    }
}

export interface IVideoFileSegment {
    name?: string | undefined;
    creationTime?: string | undefined;
    fullPath?: string | undefined;
    videoDuration?: number;
    timeStamp?: dayjs.Dayjs;
    time?: string | undefined;
    timeRange?: ValueTupleOfStringAndString;
    hour?: number;
    minute?: number;
    hourStr?: string | undefined;
}

export class ValueTupleOfStringAndString implements IValueTupleOfStringAndString {
    item1?: string | undefined;
    item2?: string | undefined;

    constructor(data?: IValueTupleOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data;
    }
}

export interface IValueTupleOfStringAndString {
    item1?: string | undefined;
    item2?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
